/**
 * The `userData` marker of a node that draws nothing of its own, for tooling and tests. Its two
 * publishers share this shape: `GenericNodeFallback` for an unregistered type, and `PlainNode` for
 * a `renderIntent: 'pending'` type, whose base component runs instead of the fallback.
 */
export function placeholderUserData(node) {
    return { isPlaceholder: true, nodeType: node.type, nodeName: node.name };
}
//# sourceMappingURL=placeholderUserData.js.map